<!-- Page header -->
<div class="pageheader">
  <div class="page-title">
    <h1>Report</h1>
    <div class="btn-group">
      <button class="btn btn-link" [disabled]="vm.editing || (!vm.report.Id)" (click)="refresh()">
        <span>Refresh</span>
        <ep-svg-icon icon="repeat"></ep-svg-icon>
      </button>
      <button class="btn btn-link" *bizPermissionRequired="'Reports_Action_Report_Create'" [disabled]="vm.editing" (click)="addNewItem()">
        <span>Create new</span>
        <ep-svg-icon icon="plus"></ep-svg-icon>
      </button>
      <app-change-log-link [hidden]="!vm.report.Id" *bizPermissionRequired="'Reports_Action_ShowLog'" [title]="'Report log'">
        <app-change-log-link-entity type="Report" [id]="vm.report.Id"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<!-- Container -->
<div class="container container-fixed mb-10">
  <!-- Top button bar -->
  <ng-container [ngTemplateOutlet]="buttonBar" [ngTemplateOutletContext]="{ top: true }"></ng-container>
  <form #myForm="ngForm">
    <dx-validation-group #vg>
      <fieldset [disabled]="!vm.editing">
        <div class="row">
          <div class="col-sm-12">
            <h2>
              <span>Report configuration</span>
              @if (vm.report.IsSystem) {
                &nbsp;<span class="label label-info">System</span>
              }
            </h2>
  
            <!-- Name -->
            <div class="form-group">
              <label for="name" title="Name the report after its purpose">Name</label>
              <input type="text" id="name" name="name" [(ngModel)]="vm.report.Name" #fName="ngModel" class="form-control" [class.invalid-state-border]="fName.invalid" required [appUniqueReportName]="vm.report.Id"
                [attr.readonly]="vm.report.IsSystem ? '' : null" />
              @if (fName.invalid && (fName.touched|| fName.dirty)) {
                @if (fName.errors?.uniqueReportName) {
                  <p class="error">Name is already used</p>
                }
                @else {
                  <p class="error">Required</p>
                }
              }
            </div>
  
            <!-- Description -->
            <div class="form-group">
              <label for="description" title="Describe the purpose of this report">Description</label>
              <textarea id="description" name="description" [(ngModel)]="vm.report.Description" class="form-control fit-column h-10 no-wrap-scroll" [attr.readonly]="vm.report.IsSystem ? '' : null"></textarea>
            </div>
  
            <!-- Query -->
            <div class="form-group">
              <label for="query" title="The SQL query that extracts data for the report optionally using parameters defined below">Query</label>
              <textarea id="query" name="query" [(ngModel)]="vm.report.Script" class="form-control fit-column h-16 monospace resizable no-wrap-scroll" [attr.readonly]="vm.report.IsSystem ? '' : null"></textarea>
            </div>
  
            <table class="macros">
              <tr>
                <th>Macro</th>
                <th>Description</th>
              </tr>
              <tr>
                <td>[[:ConfigurationDB:]]</td>
                <td>Name of configuration database</td>
              </tr>
              <tr>
                <td>[[:TransactionalDB:]]</td>
                <td>Name of transactional database</td>
              </tr>
              <tr>
                <td>[[:ToolsDB:]]</td>
                <td>Name of tools database</td>
              </tr>
              <tr>
                <td>[[:OfflineDB:]]</td>
                <td>Name of offline database</td>
              </tr>
            </table>
  
          </div>
        </div>
  
        <div class="row">
          <div class="col-sm-12">
            <h2>Parameters</h2>
  
            <!-- Parameters -->
            <dx-data-grid biz-grid stateStorageKey="reportParams" [selection]='{ mode: "single" }' [dataSource]='vm.parameters' [bizSetSummary]="false" [bizHideSelectedRowsComponent]="true"
              [bizSetGroupPanel]="false" [bizSetColumnChooser]="false" [bizSetPager]="false" [bizSetPaging]="false" [bizSetAllowColumnReordering]="false" exportFileName="Parameters"
              (onInitNewRow)="onInitNewRow($event)" (onEditingStart)="onEditingStart()" (onEditCanceled)="onEditingEnd()" (onSaved)="onEditingEnd()">
  
              <dxo-editing mode="row" [allowAdding]="vm.editing && !vm.report.IsSystem" [allowUpdating]="vm.editing" [allowDeleting]="vm.editing && !vm.report.IsSystem"></dxo-editing>
  
              <dxi-column dataField="Name" dataType="string" width="20%" [allowEditing]="!vm.report.IsSystem">
                <dxi-validation-rule type="required"></dxi-validation-rule>
              </dxi-column>
  
              <dxi-column dataField="DisplayName" dataType="string" [allowEditing]="!vm.report.IsSystem">
                <dxi-validation-rule type="required"></dxi-validation-rule>
              </dxi-column>
  
              <dxi-column dataField="Type" dataType="string" [allowEditing]="!vm.report.IsSystem">
                <dxi-validation-rule type="required"></dxi-validation-rule>
                <dxo-lookup [dataSource]="parameterTypes" valueExpr="id" displayExpr="name"></dxo-lookup>
              </dxi-column>
  
              <dxi-column dataField="DefaultValue" dataType="string">
              </dxi-column>
            </dx-data-grid>
          </div>
        </div>
  
        <div class="row mt-1">
          <div class="col-sm-12">
            <h2>Schedule</h2>
  
            <div style="display:flex; gap: 2rem;">
  
              <!-- Enable -->
              <div class="control control-checkbox lg control-form-group" style="flex-grow: 0">
                <label for="enable" title="Check to enable scheduled report execution">
                  <span>Enable</span>
                  <input type="checkbox" id="enable" name="enable" [(ngModel)]="vm.scheduledItem.Enabled" #fEnable="ngModel" />
                  <i></i>
                </label>
              </div>
  
              <!-- Send to -->
              @if (fEnable.value) {
              <div class="form-group" style="flex-grow: 3">
                <label for="sendTo">Send report to</label>
                <input type="text" id="sendTo" name="sendTo" [(ngModel)]="vm.report.SendTo" #fSendTo="ngModel" class="form-control" [class.invalid-state-border]="fSendTo.invalid" required
                  [disabled]="!fEnable.value" placeholder="Email address"
                  pattern="^\s*((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])(\s*;\s*((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W]))*\s*;?\s*$" />
                <!-- Pattern is email followed by semicolon and email, optionally padded with whitespace -->
                @if (fSendTo.invalid && fSendTo.touched) {
                <p class="error">Valid email address required (use ; to separate multiple email addresses)</p>
                }
              </div>
              }
  
              <!-- Send as -->
              @if (fEnable.value) {
              <div class="form-group" style="flex-grow: 1">
                <label for="sendAs">Send report as</label>
                <select id="sendAs" name="sendAs" [(ngModel)]="vm.report.SendAs" #fSendAs="ngModel" class="form-control" [class.invalid-state-border]="fSendAs.invalid" required
                  [disabled]="!fEnable.value">
                  <option [ngValue]="null" hidden disabled>Select...</option>
                  @for (item of sendAsOptions; track item) {
                  <option [ngValue]="item.id">{{ item.name }}</option>
                  }
                </select>
                @if (fSendAs.invalid && fSendAs.touched) {
                <p class="error">Required</p>
                }
              </div>
              }
  
            </div>
  
            <!-- Schedule -->
            @if (fEnable.value) {
            <div>
              <ep-schedule-item #reportSchedule [(scheduleItem)]="vm.scheduledItem" [hideTriggerEnd]="true" [requireAtLeastOneTrigger]="vm.scheduledItem.Triggers?.length === 0"
                [readonly]="!(vm.editing && fEnable.value)" [validateTriggerTimes]="true" [requireWeekdaySelection]="true">
              </ep-schedule-item>
            </div>
            }
          </div>
        </div>
      </fieldset>
    </dx-validation-group>
  </form>

  <!-- Bottom button bar -->
  <div class="mt-1">
    <ng-container [ngTemplateOutlet]="buttonBar" [ngTemplateOutletContext]="{ top: false }"></ng-container>
  </div>

</div> <!-- End container -->

<ng-template #buttonBar let-top="top">

  <!-- Button bar -->
  <div class="row">
    <div class="col-sm-12">
      <div class="form-group btn-toolbar">

        @if (vm.editing) {
        <div class="btn-group">
          <button type="button" class="btn btn-primary btn-sm" (click)="save()" [disabled]="!canSave()">Save</button>
        </div>
        <div class="btn-group">
          <button type="button" class="btn btn-primary btn-sm" (click)="cancel()">Cancel</button>
        </div>
        }
        @else {
        <div class="btn-group">
          <button type="button" class="btn btn-primary btn-sm" (click)="edit()" *bizPermissionRequired="['Reports_Action_Report_Create', 'Reports_Action_Report_Edit']">Edit</button>
        </div>
        }

        @if (top) {
        <div class="btn-group">
          <button type="button" class="btn btn-primary btn-sm" (click)="delete()" [disabled]="vm.editing || vm.report.IsSystem" *bizPermissionRequired="'Reports_Action_Report_Delete'">Delete</button>
        </div>
        <div class="btn-group">
          <button type="button" class="btn btn-primary btn-sm" (click)="runReport()" [disabled]="vm.editing">Run</button>
        </div>
        }

      </div>
    </div>
  </div>

</ng-template>
